/**
 * URL
 */
export enum URL {
  /**
   * BaseURL
   */
  //  BaseURL = 'https://airspo.synology.me:12345',
  BaseURL = 'https://airspo.synology.me:12345/public',
  /**
   * 祝日全件検索
   */
  AllSearch = 'holiday/getAll',
  /**
   * 祝日年年検索
   */
  YearSearch = 'holiday/getYearSearch',
}

/**
 * 戻り値のタイプ
 * @name ResultType
 */
export enum ResultType {
  /**
   * 成功
   * @name Success
   */
  Success = 0,
  /**
   * システムエラー
   * @name SystemError
   */
  SystemError = -9,
}

/**
 * ダイアログタイプ
 */
export enum DialogType {
  /**
   * OKのみ
   */
  OKOnly,
  /**
   * Loading
   */
  Loading,
}
